
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gRg7d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73bb0e29c7f7a728c3573234fe0b4d23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c45e18c0fa2cbf05$var$_react = $c45e18c0fa2cbf05$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c45e18c0fa2cbf05$var$_emojiAdd = $c45e18c0fa2cbf05$var$_interopRequireDefault((parcelRequire("4FHTF")));

var $c45e18c0fa2cbf05$var$_emojiAdd2 = $c45e18c0fa2cbf05$var$_interopRequireDefault((parcelRequire("3puEE")));
function $c45e18c0fa2cbf05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiAddIcon.
 * This component is EmojiAddIcon, with `UNSAFE_fallbackIcon` set to "EmojiAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c45e18c0fa2cbf05$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $c45e18c0fa2cbf05$var$_react.default.createElement($c45e18c0fa2cbf05$var$_emojiAdd.default, Object.assign({
        LEGACY_fallbackIcon: $c45e18c0fa2cbf05$var$_emojiAdd2.default
    }, props));
$c45e18c0fa2cbf05$var$EmojiAddIcon.Name = 'EmojiAddIconMigration';
var $c45e18c0fa2cbf05$var$_default = module.exports.default = $c45e18c0fa2cbf05$var$EmojiAddIcon;

});


//# sourceMappingURL=emoji-add.49906434.js.map
